import { render, staticRenderFns } from "./OrganisationTab.vue?vue&type=template&id=6036272c&scoped=true"
import script from "./OrganisationTab.vue?vue&type=script&lang=js"
export * from "./OrganisationTab.vue?vue&type=script&lang=js"
import style0 from "./OrganisationTab.vue?vue&type=style&index=0&id=6036272c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6036272c",
  null
  
)

export default component.exports